import React, { cloneElement, ReactElement } from "react";

export interface IEpiserverPropertyProps {
  isInEditMode: boolean;
  propertyName: string;
  wrappingElement?: string;
  usingDangerouslySetInnerHTML?: boolean;
}

export class EpiserverProperty extends React.Component<IEpiserverPropertyProps> {
  get subChild(): ReactElement {
    return React.Children.only(this.props.children) as ReactElement;
  }
  get innerData() {
    const subChild = this.subChild;
    if (!subChild) {
      console.error("EpiserverProperty requires 1 singular child node.");
      return;
    }
    return subChild.props?.children;
  }

  public render() {
    const {
      isInEditMode,
      propertyName,
      children,
      wrappingElement,
      usingDangerouslySetInnerHTML,
    } = this.props;
    const wrap = wrappingElement || "div";
    let shouldRenderAsNormal = !isInEditMode;

    if (usingDangerouslySetInnerHTML) {
      if (!this.subChild.props.dangerouslySetInnerHTML?.__html)
        shouldRenderAsNormal = false;
    } else {
      if (!this.innerData) shouldRenderAsNormal = false;
    }
    return (
      <>
        {shouldRenderAsNormal && children}

        {isInEditMode &&
          !usingDangerouslySetInnerHTML &&
          cloneElement(this.subChild, {
            ...this.subChild.props,
            children: React.createElement(
              wrap,
              {
                "data-epi-property-name": propertyName,
                "data-epi-use-mvc": "True",
                className: "display-block",
              },
              this.innerData
            ),
          })}

        {isInEditMode &&
          usingDangerouslySetInnerHTML &&
          cloneElement(this.subChild, {
            ...this.subChild.props,
            "data-epi-property-name": propertyName,
            "data-epi-use-mvc": "True",
          })}
      </>
    );
  }
}
